// @flow

import React, { PureComponent } from 'react';

import { dynamicClassName } from 'utils/dynamicClassName';
import type { RencontreActionType, RencontreActionContainerType } from 'types/Rencontre';
import { getIconClassName, extractHalf } from 'utils/rencontreUtils';

const MAX_MINUTES = (periode) => periode === 1 ? 40 : 80;

type Props = {
  actions: RencontreActionContainerType[],
  localScoreMid: number,
  visiteurScoreMid: number,
  isMatchEnd?: boolean,
}

type State = {
  firstHalf: RencontreActionType[],
  secondHalf: RencontreActionType[],
}

class RencontreHighlights extends PureComponent<Props, State> {
  static defaultProps = {
    isMatchEnd: false,
  };

  state: State = {
    firstHalf: [],
    secondHalf: [],
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const { actions } = props;

    if (actions && actions.length > 0) {
      return { ...extractHalf(actions) };
    }

    return null;
  }

  _renderMinute = (minutes: number, periode: number) => {
    const minSup = minutes - MAX_MINUTES(periode);
    const displayedMinSup = minSup > 0 ? `+ ${minSup}` : '';
    return <b>{Math.min(minutes, MAX_MINUTES(periode))} &apos; {displayedMinSup}</b>;
  };

  _renderInfo = (type: string, sousType: string, joueur: string, joueur2: string) => {
    const displayedType = type.includes('_') ? `${type.split('_')[0]} ${type.split('_')[1]}` : type;

    return (
      <>
        <>{`${displayedType.substr(0, 1).toUpperCase()}${displayedType.slice(1)}`}&nbsp;</>
        {type === 'essai' && sousType === 'De pénalité' && <span>{sousType}</span>}
        {type === 'remplacement' && 
          <span>{joueur} <i className="icon icon-substitution"/> {joueur2}</span>}
        {type !== 'remplacement' && 
        <span>{joueur}</span>}
      </>
    );
  };

  _renderLocalHighlight = (action: RencontreActionType) => {
    const { minutes, periode, type, sousType, joueur, joueur2 } = action;
    return (
      <div className="highlight__circle">
        <p className="circle__content circle__content--left circle__content--info">
          {this._renderInfo(type, sousType, joueur ? joueur.displayName : '', joueur2 ? joueur2.displayName : '')}
        </p>
        <div className="circle__icon">
          <i className={getIconClassName(type)}/>
        </div>
        <p className="circle__content circle__content--right circle__content--time">
          {this._renderMinute(minutes, periode)}
        </p>
      </div>
    );
  };

  _renderVisiteurHighlight = (action: RencontreActionType) => {
    const { minutes, periode, type, sousType, joueur, joueur2 } = action;
    return (
      <div className="highlight__circle">
        <p className="circle__content circle__content--left circle__content--time">
          {this._renderMinute(minutes, periode)}
        </p>
        <div className="circle__icon">
          <i className={getIconClassName(type)}/>
        </div>
        <p className="circle__content circle__content--right circle__content--info">
          {this._renderInfo(type, sousType, joueur ? joueur.displayName : '', joueur2 ? joueur2.displayName : '')}
        </p>
      </div>
    );
  };

  _renderHighlightsCircles = (actions: RencontreActionType[], withLast: boolean): Array<React$Element<'div'>> => {
    return actions.map((action, index) => {
      const { id, isLocal, joueur, minutes } = action;

      const divClassName = dynamicClassName('highlight__circle');
      //index === 0 && divClassName.add('highlight__circle--last');
      index === (actions.length - 1) && withLast && divClassName.add('highlight__circle--first');
      console.log(action, isLocal);
      return (
        <div key={`${id}_${joueur ? joueur.displayName : ''}_${minutes}'`} className={divClassName.build()}>
          {isLocal && this._renderLocalHighlight(action)}
          {!isLocal && this._renderVisiteurHighlight(action)}
        </div>
      );
    });
  };

  render() {
    const { localScoreMid, visiteurScoreMid, isMatchEnd } = this.props;
    const { firstHalf, secondHalf } = this.state;

    const localClass = (localScoreMid > visiteurScoreMid && 'is-winner') || '';
    const visiteurClass = (visiteurScoreMid > localScoreMid && 'is-winner') || '';
    const titleEnd = isMatchEnd ? ' Fin du match ' : ` ${secondHalf && secondHalf[0] && secondHalf[0].minutes} '`;
    const hasSecondHalf = secondHalf && secondHalf.length > 0;
    console.log(firstHalf);
    return (
      <div className="highlight">
        {hasSecondHalf && <div className="highlight__title highlight__title--end">{titleEnd}</div>}
        {hasSecondHalf && this._renderHighlightsCircles(secondHalf, !!isMatchEnd)}
        {hasSecondHalf && 
        <div className="highlight__halfTime">
          <div>mi-temps</div>
          <p>
            <span className={localClass}>{localScoreMid}</span>
            &nbsp;:&nbsp;
            <span className={visiteurClass}>{visiteurScoreMid}</span>
          </p>
        </div> }
        {firstHalf && firstHalf.length > 0 && this._renderHighlightsCircles(firstHalf, true)}
        <div className="highlight__title highlight__title--start"> Début de match </div>
      </div>
    );
  }
}

export default RencontreHighlights;
